import { IMAGE_ALT } from '../../seo/imageAltText';
import PictureImage from '../../components/Common/PictureImage';
import React from 'react';
import { Link } from 'react-router-dom';
import './ShopifyBenefits.css';

const features = [
  {
    icon: (
      <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden>
        <rect x="2" y="2" width="16" height="16" rx="4" fill="#22C55E" />
        <path d="M6 10.5l3 3 5-5" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    text: 'Secure UK warehouse storage',
  },
  {
    icon: (
      <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden>
        <rect x="2" y="3" width="16" height="14" rx="2" stroke="#3B82F6" strokeWidth="1.5" />
        <rect x="5" y="6" width="2" height="8" rx="0.5" fill="#3B82F6" />
        <rect x="9" y="6" width="1" height="8" rx="0.5" fill="#3B82F6" />
        <rect x="12" y="6" width="2" height="8" rx="0.5" fill="#3B82F6" />
      </svg>
    ),
    text: 'Barcode-based inventory management',
  },
  {
    icon: (
      <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden>
        <rect x="3" y="2" width="14" height="16" rx="2" stroke="#8B5CF6" strokeWidth="1.5" />
        <path d="M6 7h8M6 10h8M6 13h5" stroke="#8B5CF6" strokeWidth="1.3" strokeLinecap="round" />
        <path d="M13 12l1.5 1.5L16 12" stroke="#8B5CF6" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    text: 'Defined quality control processes',
  },
  {
    icon: (
      <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden>
        <rect x="2" y="12" width="3" height="6" rx="0.5" fill="#6366F1" />
        <rect x="7" y="8" width="3" height="10" rx="0.5" fill="#6366F1" />
        <rect x="12" y="5" width="3" height="13" rx="0.5" fill="#6366F1" />
        <rect x="17" y="2" width="1" height="16" rx="0.5" fill="#6366F1" />
      </svg>
    ),
    text: (
      <>
        <Link to="/multi-channel-fulfillment-services" className="shopify-inline-link">
          Multi-channel fulfilment
        </Link>{' '}
        readiness
      </>
    ),
  },
  {
    icon: (
      <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden>
        <circle cx="10" cy="10" r="8" stroke="#F97316" strokeWidth="1.5" />
        <path d="M10 6v4l3 2" stroke="#F97316" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
    text: 'Same-day order processing before 6 PM',
  },
  {
    icon: (
      <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden>
        <path d="M3 17l4-4 3 3 4-5 3 3" stroke="#14B8A6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="4" cy="6" r="2" stroke="#14B8A6" strokeWidth="1.3" />
        <circle cx="10" cy="4" r="2" stroke="#14B8A6" strokeWidth="1.3" />
        <circle cx="16" cy="6" r="2" stroke="#14B8A6" strokeWidth="1.3" />
      </svg>
    ),
    text: 'Real-time inventory reporting dashboard',
  },
  {
    icon: (
      <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden>
        <rect x="2" y="5" width="16" height="12" rx="2" stroke="#F43F5E" strokeWidth="1.5" />
        <path d="M6 5V4a2 2 0 014 0v1" stroke="#F43F5E" strokeWidth="1.3" />
        <path d="M10 10v3M8 11.5h4" stroke="#F43F5E" strokeWidth="1.3" strokeLinecap="round" />
      </svg>
    ),
    text: (
      <>
        Dedicated{' '}
        <Link to="/return-handling-services" className="shopify-inline-link">
          returns management
        </Link>{' '}
        service
      </>
    ),
  },
];

const BuiltToGrow: React.FC = () => {
  return (
    <section className="btg-section">
      <div className="btg-content">
        <div className="btg-text">
          <h2 className="btg-title">
            Scalable UK Fulfilment Built to Support Your{' '}
            <strong>
              <span style={{ color: '#e07b20' }}>Shopify Growth</span>
            </strong>
          </h2>
          <p className="btg-desc">
            As your Shopify store grows, our Shopify fulfilment solution in the UK scales with you. Our{' '}
            <Link to="/our-fulfilment-center" className="shopify-inline-link">
              fulfilment centre in the UK
            </Link>{' '}
            combines secure warehouse storage, inventory management, and efficient order processing to support
            increasing demand without operational complexity.
          </p>
          <ul className="btg-list">
            {features.map((f, i) => (
              <li className="btg-item" key={i}>
                <span className="btg-icon">{f.icon}</span>
                <span className="btg-item-text">{f.text}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="btg-image-wrap">
          <PictureImage
            width={800}
            height={800}
            src="/Images/ShopifyPage/3.webp"
            alt={IMAGE_ALT.shopifyBenefitsPallet}
            className="btg-img"
            loading="lazy"
          />
          <div className="btg-img-fade" />
        </div>
      </div>
    </section>
  );
};

export default BuiltToGrow;
